// extracted by mini-css-extract-plugin
module.exports = {"callback":"style-module--callback--2tksj","link":"style-module--link--3t2mU","link_wrapper":"style-module--link_wrapper--37uTN","phone":"style-module--phone--3N1Mn"};